
export default function usFormat  (currency : number | string) {
        
        if (currency !== null && currency !== undefined) {
                return currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        }

}

